import axios, { type AxiosError, HttpStatusCode } from 'axios';

const MAX_RETRIES = 1;

export async function fetchEsmReport<TBody = any, TReport = any, TFallback = any>({
  signal,
  body,
  maxRetries = MAX_RETRIES,
  url,
}: {
  signal?: AbortSignal;
  body: TBody;
  maxRetries?: number;
  url: string;
}): Promise<TReport | TFallback> {
  let reportResponse;
  let attemptRetry = false;
  let retryCounter = 0;

  do {
    try {
      reportResponse = await axios.post(url, body, { signal });
      attemptRetry = false;
    } catch (error) {
      if ((error as AxiosError)?.response?.status !== HttpStatusCode.NotFound) {
        throw error;
      }
      attemptRetry = true;
      retryCounter++;
    }
  } while (retryCounter <= maxRetries && attemptRetry);

  return reportResponse?.data;
}
